import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import GenericToggleButtonGroupField from '../../commons/form-fields/GenericToggleButtonGroupField';
import { yesNoOptions } from '../../onboarding/OnboardingConstants';
import { getInvoicingAdditionalChecksByCountry } from '../../commons/CountryUtils';

const ConsultantInvoiceAdditionalChecksSection = ({ consultantCountry }) => {
    const additionalChecks =
        getInvoicingAdditionalChecksByCountry(consultantCountry);

    // Don't render section if no additional checks for the consultant's country
    if (_.isEmpty(additionalChecks)) {
        return <div />;
    }

    return (
        <div>
            <div className="mt-5 mb-4">
                {_.map(additionalChecks, (checkConfig, checkKey) => (
                    <GenericToggleButtonGroupField
                        name={`consultantInvoiceAdditionalChecks.${checkKey}`}
                        inlineLabel={checkConfig?.text}
                        options={yesNoOptions}
                        required
                    />
                ))}
            </div>
        </div>
    );
};

ConsultantInvoiceAdditionalChecksSection.propTypes = {
    consultantCountry: PropTypes.string.isRequired,
};

export default ConsultantInvoiceAdditionalChecksSection;
